import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

import { DATA_HOOK } from './InputShell.constants';

export const inputShellDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    /**
     * Returns the tag name of the HTML element
     * @returns {Promise<string>}
     */
    getTagName: async (): Promise<string> =>
      (await base._prop('tagName')).toLowerCase(),
    /**
     * Returns true if dropdown arrow is displayed
     */
    hasMenuArrow: async (): Promise<boolean> => {
      const component = findByHook(base, DATA_HOOK.menuArrow);
      return component.exists();
    },
    isDisabled: async () => (await base._prop('disabled')) === true,
  };
};

export type InputShellUniDriver = ReturnType<typeof inputShellDriverFactory>;
